import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderSlot as _renderSlot } from "vue"
import _imports_0 from '../../../../img/Axxess_Intelligence_logo_2.svg'


const _hoisted_1 = { class: "card-body p-0" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "mb-0 d-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary" }, null, -1 /* HOISTED */)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", { class: "ai-premium-btn ms-2 mt-1" }, "Premium", -1 /* HOISTED */)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-xs fa-times" }, null, -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "ai-line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPill = _resolveComponent("ProductPill")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card col-${_ctx.size} bg-${_ctx.showBackground ? _ctx.currentConfiguration.backgroundClass : ''} ${
            _ctx.showBackground ? _ctx.currentConfiguration.borderClass : ''
        } ${_ctx.type} form-section material-card ${_ctx.fullHeight ? 'full-height' : ''}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(`p-2 ${_ctx.currentConfiguration.titleClass} d-flex justify-content-between align-items-center`)
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h6", _hoisted_3, [
                _createElementVNode("b", {
                  class: _normalizeClass(`me-2 ${_ctx.titleClass}`)
                }, _toDisplayString(_ctx.title), 3 /* TEXT, CLASS */),
                (_ctx.popoverContent && _ctx.popoverContent.length > 0)
                  ? _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_4, _hoisted_6)), [
                      [_directive_custom_popover, {
                                content: _ctx.popoverContent,
                                placement: 'right'
                            }]
                    ])
                  : _createCommentVNode("v-if", true)
              ]),
              (_ctx.showProductPill)
                ? (_openBlock(), _createBlock(_component_ProductPill, {
                    key: 0,
                    class: "application-name",
                    "product-id": _ctx.getApplicationId(_ctx.applicationId)
                  }, null, 8 /* PROPS */, ["product-id"]))
                : _createCommentVNode("v-if", true)
            ]),
            (_ctx.isFindAMatch)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
              : _createCommentVNode("v-if", true),
            (_ctx.cancel !== null)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  class: "close-button me-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
                }, _hoisted_12))
              : _createCommentVNode("v-if", true)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (_ctx.isFindAMatch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "title"),
      _renderSlot(_ctx.$slots, "content"),
      _renderSlot(_ctx.$slots, "content_2")
    ])
  ], 2 /* CLASS */))
}